<template>
  <header>
    <div
      class="bg-indigo-1 page-title flex justify-between items-center"
      v-if="!isLogin"
    >
      <div>
        <h1 class="text-primary">{{ title }}</h1>
        <q-breadcrumbs v-if="!isParentPage && !isProfile">
          <q-breadcrumbs-el
            :label="parentPage"
            :to="'/' + parentPage.toLowerCase()"
          />
          <q-breadcrumbs-el :label="title" disable />
        </q-breadcrumbs>
        <span v-if="isParentPage || isProfile"
          >Welcome, {{ user.username }}.</span
        >
      </div>
      <q-icon v-if="icon" size="60px" :name="icon" color="indigo-2" />
    </div>
    <h1 v-if="isLogin" class="text-primary">{{ title }}</h1>
  </header>
</template>

<style></style>

<script>
import { Auth } from "aws-amplify";
export default {
  name: "PageTitle",
  props: {
    title: String,
    parentPage: String,
    icon: String,
  },
  data() {
    return {
      user: {},
    };
  },
  beforeCreate() {
    Auth.currentAuthenticatedUser()
      .then((user) => {
        this.user = user;
      })
      .catch(() => console.log("error"));
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    isParentPage() {
      return this.currentRouteName === "LiveDashboard";
    },
    isLogin() {
      return this.currentRouteName === "Login";
    },
    isProfile() {
      return this.currentRouteName === "Profile";
    },
  },
};
</script>
<style lang="scss" scoped>
.page-title {
  padding: 1em;
  h1 {
    margin: 10px 0;
  }
}
</style>
